// extracted by mini-css-extract-plugin
export default {"container":"_ac37c8df","followHeader":"_5fe33116","tilesHeader":"_8d5408c0","tilesWrapper":"_62a4f4ac","tile":"_b592becc","searchSuggestions":"_119025a9"};